<div class="fill-height p-2">
  <mat-spinner *ngIf="isLoading"></mat-spinner>
  <mat-card>
    <form class="h-100 d-flex flex-column p-2" [formGroup]="form" (submit)="onSavePaper()" *ngIf="!isLoading">
      <mat-form-field>
        <mat-label>{{ 'su-management.paper.name' | translate }}</mat-label>
        <input matInput type="text" formControlName="paperName" [placeholder]="'su-management.paper.name' | translate">
        <mat-error *ngIf="form.get('paperName').invalid">{{ 'su-management.paper.please-enter-name' | translate }}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'su-management.paper.width' | translate }}</mat-label>
        <input matInput type="number" formControlName="paperWidth" [placeholder]="'su-management.paper.width' | translate">
        <mat-error *ngIf="form.get('paperWidth').invalid">{{ 'su-management.paper.please-enter-width' | translate }}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'su-management.paper.height' | translate }}</mat-label>
        <input matInput type="number" formControlName="paperHeight" [placeholder]="'su-management.paper.height' | translate">
        <mat-error *ngIf="form.get('paperHeight').invalid">{{ 'su-management.paper.please-enter-height' | translate }}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'su-management.paper.weight' | translate }}</mat-label>
        <input matInput type="number" formControlName="paperWeight" [placeholder]="'su-management.paper.weight' | translate">
        <mat-error *ngIf="form.get('paperWeight').invalid">{{ 'su-management.paper.please-enter-weight' | translate }}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'su-management.paper.printer-code' | translate }}</mat-label>
        <input matInput type="text" formControlName="paperPrinterCode" [placeholder]="'su-management.paper.printer-code' | translate">
        <mat-error *ngIf="form.get('paperPrinterCode').invalid">{{ 'su-management.paper.please-enter-printer-code' | translate }}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'su-management.paper.printer-quality' | translate }}</mat-label>
        <input matInput type="number" formControlName="paperPrinterQuality" [placeholder]="'su-management.paper.printer-quality' | translate">
        <mat-error *ngIf="form.get('paperPrinterQuality').invalid">{{ 'su-management.paper.please-enter-printer-quality' | translate }}</mat-error>
      </mat-form-field>
      <mat-checkbox [(ngModel)]="form.value.isExpress" formControlName="isExpress">{{ 'su-management.paper.is-express' | translate }}</mat-checkbox>
      <mat-checkbox [(ngModel)]="form.value.isPlotter" formControlName="isPlotter">{{ 'su-management.paper.is-plotter' | translate }}</mat-checkbox>
      <mat-checkbox [(ngModel)]="form.value.isPh" formControlName="isPh">{{ 'su-management.paper.is-ph' | translate }}</mat-checkbox>

      <button #hiddenSubmitBtn type="submit" style="display: none;"></button>

    </form>
  </mat-card>
</div>

<div class="p-2">
  <div class="d-flex flex-column flex-md-row gap-2">
    <button class="w-100 rounded-pill" mat-raised-button color="primary" type="button" (click)="submitForm()">
      {{ 'su-management.paper.save' | translate }}
    </button>
    <button class="w-100 rounded-pill" *ngIf="isModeEdit" mat-raised-button color="primary" type="button"
      (click)="backToPapers()">
      {{ 'su-management.paper.dont-save-changes' | translate }}
    </button>
    <button class="w-100 rounded-pill" mat-raised-button type="button" (click)="toPapersList()">
      {{ 'su-management.paper.list' | translate }}
    </button>
  </div>
</div>